export class IngresoEgreso {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo: {
                value: null,
                export: false,
                table: true,
                header: 'Detalle:',
                required: 'Detalle es requerido',
            },
            otro_detalle: {
                value: '',
                export: false,
                table: false,
                header: '*ESPECIFICAR OTROS INGRESOS:',
                required: 'Campo es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },                
            valor: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'Valor USD:',
                required: 'Valor es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
